import {
  FormField,
  Textarea,
} from '@cloudscape-design/components';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';

export default function ChannelMetadataFields({ params, onChange }) {
  const [localInfo, setLocalInfo] = useState(params.info);

  useEffect(() => {
    setLocalInfo(params.info);
  }, [params.info]);

  return (
    <FormField label="Channel info">
      <Textarea
        value={localInfo}
        onChange={({ detail }) => setLocalInfo(detail.value)}
        onBlur={() => onChange('info', localInfo)}
        placeholder="Liquid name, channel notes, or any channel-specific context"
      />
    </FormField>
  );
}
ChannelMetadataFields.propTypes = {
  params: PropTypes.shape({
    info: PropTypes.string.isRequired,
  }).isRequired,
  onChange: PropTypes.func.isRequired,
};
